import React from "react";

const ProjectIntro = ({ pfrFormData, setPfrFormData }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPfrFormData("projectIntro", {
      [name]: value,
    });
  };

  return (
    <>
      <div className="form-section">
        <h3>Introduction of the Project / Background Information</h3>
        <div className="form-group">
          <label className="requried">
            Identification of Project and project proponent
          </label>
          <textarea
            type="text"
            name="identification"
            value={pfrFormData.projectIntro.identification}
            onChange={handleInputChange}
            placeholder="Enter Identification of Project and project proponent"
            required
          />
        </div>
        <div className="form-group">
          <label className="requried">
            Brief description of nature of the project
          </label>
          <textarea
            type="text"
            name="description"
            value={pfrFormData.projectIntro.description}
            onChange={handleInputChange}
            placeholder="Enter Brief description of nature of the project"
            required
          />
        </div>
        <div className="form-group">
          <label className="requried">Need and Importance of the Project</label>
          <textarea
            type="text"
            name="need"
            value={pfrFormData.projectIntro.need}
            onChange={handleInputChange}
            placeholder="Enter Need and Importance of the Project"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Demand-Supply Gap</label>
          <textarea
            type="text"
            name="demandSupplyGap"
            value={pfrFormData.projectIntro.demandSupplyGap}
            onChange={handleInputChange}
            placeholder="Enter Demand-Supply Gap"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Imports Vs. Indigenous Production</label>
          <textarea
            type="text"
            name="importsVsIndigenous"
            value={pfrFormData.projectIntro.importsVsIndigenous}
            onChange={handleInputChange}
            placeholder="Enter Imports Vs. Indigenous Production"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Export Possibility</label>
          <textarea
            type="text"
            name="exportPossibility"
            value={pfrFormData.projectIntro.exportPossibility}
            onChange={handleInputChange}
            placeholder="Enter Export Possibility"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Domestic/Export Markets</label>
          <textarea
            type="text"
            name="domesticExportMarkets"
            value={pfrFormData.projectIntro.domesticExportMarkets}
            onChange={handleInputChange}
            placeholder="Enter Domestic/Export Markets"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">
            Employment Generation (Direct and Indirect) due to the project
          </label>
          <textarea
            type="text"
            name="employmentGeneration"
            value={pfrFormData.projectIntro.employmentGeneration}
            onChange={handleInputChange}
            placeholder="Enter Employment Generation (Direct and Indirect) due to the project"
            required
          />
        </div>
        <div className="form-group">
          <label className="requried">Minning Mate</label>
          <input
            type="text"
            name="minningMate"
            value={pfrFormData.projectIntro.minningMate}
            onChange={handleInputChange}
            placeholder="Enter Minning Mate"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Chowkidars</label>
          <input
            type="text"
            name="chowkidars"
            value={pfrFormData.projectIntro.chowkidars}
            onChange={handleInputChange}
            placeholder="Enter Chowkidars"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Unskilled Labors</label>
          <input
            type="text"
            name="unskilledLabors"
            value={pfrFormData.projectIntro.unskilledLabors}
            onChange={handleInputChange}
            placeholder="Enter Unskilled Labors"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Skilled Labors</label>
          <input
            type="text"
            name="skilledLabors"
            value={pfrFormData.projectIntro.skilledLabors}
            onChange={handleInputChange}
            placeholder="Enter Skilled Labors"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Total Workers</label>
          <input
            type="text"
            name="totalWorkers"
            value={pfrFormData.projectIntro.totalWorkers}
            onChange={handleInputChange}
            placeholder="Enter Total Workers"
            required
          />
        </div>
      </div>
    </>
  );
};

export default ProjectIntro;
